var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uniqueness-dropdown"},[_c('Multiselect',{attrs:{"label":"Milestone uniqueness","value":_vm.localValue,"disabled":_vm.disabled,"options":_vm.options},on:{"input":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }